var React = require('react');

function RedCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M288.71,13.24c-329.46-69.13-398.37,460-78.24,479.12s407.7-410,78.24-479.12","fill":"#b01a21"}));
}

RedCircleInline.defaultProps = {"viewBox":"0 0 500 500"};

module.exports = RedCircleInline;

RedCircleInline.default = RedCircleInline;
